import React, { useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";

// hooks and utilities
import { useLanguage, useTranslateFunction } from "lang/Translate";

// common components
import BallGridPulseLoader from "components/common/BallGridPulseLoader/BallGridPulseLoader";

//components
import GoogleLogin from "./GoogleLogin";
import Errors from "./Errors";

//css
import "./scss/Form.scoped.scss";

//php
import api from "api/api";

const Login = () => {
	const [errors, setErrors] = useState([]);
	const [requestInProgress, setRequestInProgress] = useState(false);

	const lang = useLanguage();
	const history = useHistory();
	const dispatch = useDispatch();
	const translate = useTranslateFunction("Login");
	const formRef = useRef(null);

	async function logIn() {
		setRequestInProgress(true);

		const formData = new FormData(formRef.current);
		const credentials = {
			email: formData.get("email"),
			password: formData.get("password"),
			lang: lang
		};

		try {
			const version = require("../../../package.json").version;
			const { data } = await axios.post(`${api}/auth/login?type=email&version=${version}`, credentials, {
				headers: { "content-type": "application/x-www-form-urlencoded" }
			});

			dispatch({ type: "LOGIN" });

			window.lastUsedVersion = data.lastUsedVersion;

			if (!data.hasGroup) {
				history.push("/createGroup");
				return;
			}

			if (!data.hasAirline) {
				history.push("/createAirline");
				return;
			}

			history.push("/game");
		} catch (e) {
			switch (e.response.status) {
				case 401:
					setErrors([{ error: e.response.data.error, errorEn: e.response.data.errorEn }]);
					break;
				case 403:
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.set("email", credentials.mail);
					searchParams.set("type", "pending");

					if (e.response.data.lastCodeStillActive) {
						searchParams.set("resend", true);
					}

					const l = window.location;
					const newUrl = l.origin + l.pathname + "?" + searchParams.toString() + l.hash;
					window.history.pushState({}, "", newUrl);
					history.push("/verification");
					return;
				default:
					console.error(e);
					alert("Error!");
					break;
			}
		} finally {
			setRequestInProgress(false);
		}
	}

	if (requestInProgress) {
		return (
			<div className="main" style={{ display: "grid", placeContent: "center", height: "27rem" }}>
				<BallGridPulseLoader color="hsla(215, 50%, 23%, 1)" />
			</div>
		);
	}

	return (
		<div className="main">
			<h1>{translate("LABEL")}</h1>
			<div className="form_container">
				<form onSubmit={logIn} ref={formRef}>
					<div className="input">
						<div className="icon">
							<i className="fas fa-envelope" aria-hidden="true" />
						</div>
						<input type="email" placeholder={translate("EMAIL")} autoComplete="email" name="email" />
					</div>

					<div className="input">
						<div className="icon">
							<i className="fas fa-key" aria-hidden="true" />
						</div>
						<input
							type="password"
							placeholder={translate("PASSWORD")}
							autoComplete="current-password"
							name="password"
						/>
					</div>

					<Errors errors={errors} />

					<div className="button_container">
						<input type="submit" value={translate("LOGIN")} />
						<GoogleLogin setLoading={setRequestInProgress} />
					</div>

					<Link to="/signup" className="block">
						<button className="register">{translate("REGISTER")}</button>
					</Link>
				</form>
			</div>
		</div>
	);
};

export default Login;
